import React, { useEffect, useState } from "react";

const Navbar = () => {
  const [menuAbierto, setMenuAbierto] = useState(false);

  const irASeccion = (idSeccion) => {
    const seccion = document.getElementById(idSeccion);

    if (seccion) {
      seccion.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }

    setMenuAbierto(false);
  };

  useEffect(() => {
    const manejarResize = () => {
      if (window.innerWidth >= 768) {
        setMenuAbierto(false);
      }
    };

    window.addEventListener("resize", manejarResize);

    document.body.style.overflow = menuAbierto ? "hidden" : "";

    return () => {
      window.removeEventListener("resize", manejarResize);
      document.body.style.overflow = "";
    };
  }, [menuAbierto]);

  const secciones = [
    ["inicio", "INICIO"],
    ["sobre-mi", "SOBRE MÍ"],
    ["tecnologias", "TECNOLOGÍAS"],
    ["experiencias", "EXPERIENCIAS"],
    ["proyectos", "PROYECTOS"],
    ["contacto", "CONTACTO"],
  ];

  return (
    <>
      <style>
        {`
          @keyframes desplegarMenu {
            from {
              opacity: 0;
              transform: translateY(-20px);
            }

            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .menu-movil-animacion {
            animation: desplegarMenu 0.3s ease-out forwards;
            transform-origin: top;
          }

          @media (prefers-reduced-motion: reduce) {
            .menu-movil-animacion {
              animation: none;
            }
          }
        `}
      </style>

      <header className="fixed left-0 top-0 z-50 w-full border-b border-white/50 bg-[#1c2143] shadow-[0_8px_20px_rgba(0,0,0,0.35)]">
        <div className="mx-auto flex h-[66px] max-w-[1400px] items-center justify-between px-4 sm:px-6">
          <button
            onClick={() => irASeccion("inicio")}
            className="flex items-center text-[40px] font-black leading-none tracking-[-3px] transition duration-300 hover:scale-105"
            aria-label="Ir al inicio"
          >
            <span className="bg-gradient-to-b from-red-400 via-red-600 to-red-800 bg-clip-text text-transparent">
              M
            </span>

            <span className="bg-gradient-to-b from-yellow-300 via-yellow-500 to-yellow-700 bg-clip-text text-transparent">
              F
            </span>

            <span className="bg-gradient-to-b from-[#fff] via-[#a2a7c0] to-[#676e95] bg-clip-text text-transparent">
              L
            </span>
          </button>

          <nav className="hidden items-center gap-3 md:flex">
            {secciones.map(([id, nombre]) => (
              <button
                key={id}
                onClick={() => irASeccion(id)}
                className="group relative overflow-hidden rounded-lg px-5 py-3 text-[17px] font-medium tracking-wide text-white transition-all duration-300 hover:scale-[1.02]"
              >
                <span className="absolute inset-0 origin-bottom scale-y-0 bg-white transition-transform duration-300 ease-out group-hover:scale-y-100" />

                <span className="relative z-10 transition-colors duration-300 group-hover:text-black">
                  {nombre}
                </span>
              </button>
            ))}
          </nav>

          <button
            onClick={() => setMenuAbierto(!menuAbierto)}
            className="relative flex h-10 w-10 flex-col items-center justify-center gap-[6px] rounded-lg transition-all duration-300 hover:scale-105 hover:bg-white/10 md:hidden"
            aria-label={menuAbierto ? "Cerrar menú" : "Abrir menú"}
          >
            <span
              className={`h-[3px] w-7 rounded-full bg-white transition-all duration-300 ease-in-out ${
                menuAbierto ? "translate-y-[9px] rotate-45" : ""
              }`}
            />

            <span
              className={`h-[3px] w-7 rounded-full bg-white transition-all duration-300 ease-in-out ${
                menuAbierto ? "opacity-0" : "opacity-100"
              }`}
            />

            <span
              className={`h-[3px] w-7 rounded-full bg-white transition-all duration-300 ease-in-out ${
                menuAbierto ? "-translate-y-[9px] -rotate-45" : ""
              }`}
            />
          </button>
        </div>
      </header>

      {menuAbierto && (
        <>
          <div
            onClick={() => setMenuAbierto(false)}
            className="fixed inset-0 z-40 bg-black/60 backdrop-blur-[2px] md:hidden"
          />

          <div className="menu-movil-animacion fixed left-0 top-[66px] z-50 w-full border-b border-white/10 bg-[#1c2143] px-4 py-5 shadow-xl sm:px-6 sm:py-7 md:hidden">
            <div className="flex flex-col gap-1">
              {secciones.map(([id, nombre]) => (
                <button
                  key={id}
                  onClick={() => irASeccion(id)}
                  className="group relative overflow-hidden rounded-lg px-4 py-3 text-left text-[18px] font-medium tracking-wide text-white transition-all duration-300 sm:text-[19px]"
                >
                  <span className="absolute inset-0 origin-bottom scale-y-0 bg-white transition-transform duration-300 ease-out group-hover:scale-y-100" />

                  <span className="relative z-10 transition-colors duration-300 group-hover:text-black">
                    {nombre}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Navbar;